import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=7c737cb5&scoped=true&"
import script from "./Point.vue?vue&type=script&lang=ts&"
export * from "./Point.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c737cb5",
  null
  
)

export default component.exports